import axios from 'axios'
import { env } from '@ivy/fts/envInfo/envInfo'
import store from '@ivy/fts/ivyStore'
env.init()
export async function requireGet(url, data?, config?) {
  const info = await env.getInfo()
  const params = data ? data : {}
  const conf = config ? config : {}
  if (env.type === 'web') {
    return store.objects.Vue.$toast('请在App或微信中打开')
  }
  if (env.type === 'ivydad') {
    return axios.get(url, {
      params: {
        ...params,
        ...info.publicParams,
      },
      ...conf,
    })
  }
  return axios.get(url, { params: { ...params }, ...conf })
}

export async function requirePost(url, data, config?) {
  const info = await env.getInfo()
  if (env.type === 'web') {
    return store.objects.Vue.$toast('请在App或微信中打开')
  }
  if (env.type === 'ivydad') {
    return axios.post(url, { ...data, ...info.publicParams }, config)
  }
  return axios.post(url, data, config)
}

// 埋点
export async function addStatistics(info) {
  let requestConfig: any = { disableLoading: true, disableAlert: true }
  try {
    // 新的埋点表
    await requireGet(
      '/api/stat/upload/activity',
      {
        ...info,
        activity_table: 'a_app_activity_team_attend',
      },
      requestConfig
    )
  } catch (error) {
    console.log(error)
  }
}

let timerGenerator = {}
export async function startStatisticsTime(key, info) {
  try {
    const remain = +new Date()
    await addStatistics({
      p4: remain,
      ...info,
    })
    timerGenerator[Symbol.for(key)] = setInterval(async () => {
      await addStatistics({
        p4: remain,
        ...info,
      })
    }, 5000)
  } catch (err) {}
}

export async function endtStatisticsTime(key) {
  timerGenerator[Symbol.for(key)] &&
    clearInterval(timerGenerator[Symbol.for(key)])
}

export function ChangeURLArg(url) {
  this.res = url
  this.replace = (arg, arg_val) => {
    let pattern = arg + '=([^&]*)'
    let replaceText = arg_val ? arg + '=' + arg_val : ''
    let tmp = new RegExp(`&*(${arg}=)([^&]*)`, 'gi')
    this.res = this.res.replace(tmp, replaceText)
    return this
  }
  this.removeQuery = arg => {
    this.replace(arg, '')
    return this
  }
  this.getResult = () => {
    return this.res
  }
}
